import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalService } from '@core/services/presenters/modal.service';
import { ModalAlertComponent } from '@shared/design/organisms/modal-alert/modal-alert.component';
import { ToastComponent } from '@shared/design/organisms/toast/toast.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, ModalAlertComponent, ToastComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  @ViewChild(ModalAlertComponent) modalComponent!: ModalAlertComponent;
  title = 'payki-admin';

  constructor(private modalService: ModalService) {}

  ngAfterViewInit() {
    this.modalService.bindModalComponent(this.modalComponent);
  }
}
